import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";

interface Props {
  onChange: (term: string) => void;
  placeholder: string;
  ariaLabel: string;
  value?: string;
}

function SearchBox({ onChange, value, placeholder, ariaLabel }: Props) {
  return (
    <InputGroup>
      <Input
        value={value}
        type="text"
        placeholder={placeholder}
        onChange={(val) => onChange(val.target.value)}
        aria-label={ariaLabel}
      />
      <InputLeftElement>
        <FaSearch />
      </InputLeftElement>
    </InputGroup>
  );
}

export default SearchBox;
